import { writable } from "svelte/store";

export const isAuthenticated = writable(false);
export const popupOpen = writable(false);
export const token = writable();
export const email = writable();
export const role = writable();
export const signup = writable(false);
export const showDisclaimer = writable(false);